/**
 * Куда открыть приложение, если его открыли из уведомления.
 *
 * Утреннее уведомление зовёт посмотреть прогноз на день, и приводить его на
 * главную с картой дня — значит обещать одно, а показывать другое. Служебный
 * сценарий (`sw.js`) открывает адрес из самого уведомления, поэтому сервер
 * кладёт туда `?tab=astro`, а разбирает его этот файл.
 *
 * **Имя вкладки в адресе своё, не внутреннее.** Внутри астрология зовётся
 * `compat` — по первому экрану, с которого она начиналась. Тащить это имя в
 * адрес нельзя: он общий с сервером и с нативом, а переименование экрана внутри
 * не должно ломать уже разосланные уведомления.
 *
 * **Читается один раз.** Иначе параметр остаётся в адресе установленной PWA, и
 * приложение будет открываться на астрологии всегда, а не когда позвали.
 */
import type { TabId } from '../components/TabBar'

const TABS: Record<string, TabId> = {
  astro: 'compat',
  home: 'home',
  catalog: 'catalog',
  profile: 'profile',
}

export function takeNotifyTab(): TabId | null {
  try {
    const raw = new URLSearchParams(window.location.search).get('tab')
    if (!raw) return null
    const tab = TABS[raw.trim().toLowerCase()] ?? null
    // Убираем параметр из адреса, сохранив остальное: `ref` и `lang` читают
    // другие, и затирать их здесь нельзя.
    const params = new URLSearchParams(window.location.search)
    params.delete('tab')
    const rest = params.toString()
    history.replaceState(null, '', window.location.pathname + (rest ? `?${rest}` : '') + window.location.hash)
    return tab
  } catch {
    return null
  }
}
